import { StoreContext } from "@roc/feature-app-core";
import { useContext } from "react";
import { SendgridTemplatesStore } from "../stores/sendgridTemplatesStore";

export const useSendgridTemplatesStore = () => useContext<{
  sendgridTemplatesStore: SendgridTemplatesStore
}>(StoreContext);